import { __assign } from "tslib";
import React from 'react';
import { MicIcon } from '../../MessageInput/icons';
export var StartRecordingAudioButton = function (props) { return (React.createElement("button", __assign({ "aria-label": 'Start recording audio', className: 'str-chat__start-recording-audio-button', "data-testid": 'start-recording-audio-button' }, props),
    React.createElement(MicIcon, null))); };
